module.exports = __webpack_public_path__ + "img/smartphone.2b990350.svg";